export default __webpack_public_path__ + "709c7a0.png";